import { extensions } from '../../extensions/Extensions';
import { HTMLTextPipe } from './HTMLTextPipe';
import { HTMLTextSystem } from './HTMLTextSystem';

extensions.add(HTMLTextSystem);
extensions.add(HTMLTextPipe);
